'use client';
import { useQuery } from '@tanstack/react-query';
import { ReactNode, createContext } from 'react';
import type { StorefrontCategory } from '@/api/menu-list/storefront-menu-snapshot.types';
import { isAvailableNow } from '@/entities/venue/lib/useTimeAvailability';
import { QueryApi } from '@/features/query/api';
import { useStorageValue } from '@/shared/lib/storage';

export const SubCategoriesContext = createContext<{ data: StorefrontCategory[] }>({ data: [] });

type Props = {
    children?: ReactNode;
    filters: {
        parentCategoryId?: string | null;
    };
};

export const SubCategoriesProvider = ({ filters, children }: Props) => {
    const menuListsQuery = useQuery(QueryApi.MenuList.queries.MenuLists);
    const [parentCategoryId] = useStorageValue(filters.parentCategoryId);

    const subcategories =
        menuListsQuery.data?.menuLists
            .filter((menuList) => isAvailableNow(menuList.timeAvailability ?? []))
            .flatMap((menuList) => menuList.categories.flatMap((category) => category.children)) ?? [];

    return (
        <SubCategoriesContext.Provider
            value={{
                data:
                    filters.parentCategoryId && !parentCategoryId
                        ? []
                        : parentCategoryId
                          ? subcategories.filter((subcategory) => subcategory.parentId === parentCategoryId)
                          : subcategories,
            }}
        >
            {children}
        </SubCategoriesContext.Provider>
    );
};
